// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

const TITLE = 'Stitcher';

export function Stitcher() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      aria-label={TITLE}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{TITLE}</title>
      <path d="M1 8.815H4.85V15.8H1V8.815Z" fill="currentColor" />
      <path d="M19.15 8.43H23V14.865H19.15V8.43Z" fill="currentColor" />
      <path d="M14.64 7H18.49V15.36H14.64V7Z" fill="currentColor" />
      <path d="M10.13 8.21H13.98V16.24H10.13V8.21Z" fill="currentColor" />
      <path d="M5.565 7.55H9.415V15.305H5.565V7.55Z" fill="currentColor" />
    </svg>
  );
}
